mapboxgl.accessToken = 'pk.eyJ1Ijoia2luZ2tvbSIsImEiOiJjbWFwaHFicDcwZzBwMmlzM2hqYWhoc3JoIn0.fUxP1It1JgzIkLS7fuAvtg';

// Load blip icons data
let blipIcons = [];
let blipIconsLoaded = false;
let isResizing = false;

// === DOM ELEMENTS AND GLOBALS ===
let markers = [];
// Orientation setting shared with canvas-export.js
// window.currentOrientation = 'portrait';
let pinCounter = 0;
const pinsListControls = document.getElementById('pins-list-controls');
const pinsListControls_2 = document.getElementById('pins-list-controls-2');
const pinsListPreview = document.getElementById('pins-list-preview');
const mapTitlePreview = document.getElementById('map-title-preview');
const mapSubtitlePreview = document.getElementById('map-subtitle-preview');
const mapTitleInput = document.getElementById('map-title');
const mapSubtitleInput = document.getElementById('map-subtitle');
// === CREATE LOCATION BUTTON ===
function createLocationButton() {
    // Create a container for the button
    const locationButtonContainer = document.createElement('div');
    locationButtonContainer.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    locationButtonContainer.style.margin = '10px';

    // Create the button
    const locationButton = document.createElement('button');
    locationButton.className = 'location-button';
    locationButton.type = 'button';
    locationButton.title = 'Use My Location';
    locationButton.setAttribute('aria-label', 'Use My Location');
    locationButton.style.width = '30px';
    locationButton.style.height = '30px';
    locationButton.style.padding = '5px';
    locationButton.style.background = 'white';
    locationButton.style.border = 'none';
    locationButton.style.cursor = 'pointer';
    locationButton.style.display = 'flex';
    locationButton.style.alignItems = 'center';
    locationButton.style.justifyContent = 'center';

    // Add location icon
    locationButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0078FF" width="20" height="20">
            <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/>
        </svg>
    `;

    // Add hover effect
    locationButton.addEventListener('mouseenter', () => {
        locationButton.style.background = '#f0f0f0';
    });
    locationButton.addEventListener('mouseleave', () => {
        locationButton.style.background = 'white';
    });

    // Add click event to get user location
    locationButton.addEventListener('click', () => {
        getUserLocationAndCenterMap();
    });

    // Add button to container
    locationButtonContainer.appendChild(locationButton);
    return locationButtonContainer;
}

// Function to create a custom dropdown with image previews
function createCustomDropdown(container, options, selectedValue, onChange) {
    // Create the dropdown container
    const dropdownContainer = document.createElement('div');
    dropdownContainer.className = 'custom-dropdown';
    dropdownContainer.style.position = 'relative';
    dropdownContainer.style.display = 'inline-block';
    dropdownContainer.style.minWidth = 'auto';
    
    // Create the selected item display
    const selectedItem = document.createElement('div');
    selectedItem.className = 'selected-item';
    selectedItem.style.display = 'flex';
    selectedItem.style.alignItems = 'center';
    selectedItem.style.padding = '8px 0px';
    selectedItem.style.backgroundColor = '#4B5563'; // gray-600
    selectedItem.style.borderRadius = '4px';
    selectedItem.style.cursor = 'pointer';
    selectedItem.style.color = 'white';
    selectedItem.style.marginRight = '8px';
    
    // Find the selected option
    const selectedOption = options.find(opt => opt.value === selectedValue) || options[0];
    
    // Create the selected item content
    selectedItem.innerHTML = `
        <img src="${selectedOption.image}" alt="${selectedOption.text}" style="width: 20px; height: 20px;">
        <svg style="width: 16px; height: 16px; margin-left: 8px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
    `;
    
    // Create the options list
    const optionsList = document.createElement('div');
    optionsList.className = 'options-list';
    optionsList.style.display = 'none';
    optionsList.style.position = 'absolute';
    optionsList.style.top = '100%';
    optionsList.style.left = '0';
    optionsList.style.right = '0';
    optionsList.style.maxHeight = '140px';
    optionsList.style.width = '140px';
    optionsList.style.marginTop = '0px';
    optionsList.style.marginLeft = '-9px';
    optionsList.style.overflowY = 'auto';
    optionsList.style.backgroundColor = '#374151'; // gray-700
    optionsList.style.borderRadius = '4px';
    optionsList.style.marginTop = '4px';
    optionsList.style.zIndex = '1000';
    optionsList.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';
    
    // Add search input
    const searchContainer = document.createElement('div');
    searchContainer.style.padding = '8px';
    searchContainer.style.position = 'sticky';
    searchContainer.style.top = '0';
    searchContainer.style.backgroundColor = '#374151';
    searchContainer.style.zIndex = '1';
    
    const searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.placeholder = 'Search icons...';
    searchInput.style.width = '100%';
    searchInput.style.padding = '4px 8px';
    searchInput.style.backgroundColor = '#4B5563';
    searchInput.style.border = 'none';
    searchInput.style.borderRadius = '4px';
    searchInput.style.color = 'white';
    searchInput.style.fontSize = '9px';
    
    searchContainer.appendChild(searchInput);
    optionsList.appendChild(searchContainer);
    
    // Add options
    const optionsContainer = document.createElement('div');
    optionsContainer.className = 'options-container';
    
    function renderOptions(filterText = '') {
        optionsContainer.innerHTML = '';
        
        const filteredOptions = filterText 
            ? options.filter(opt => opt.text.toLowerCase().includes(filterText.toLowerCase()))
            : options;
        
        filteredOptions.forEach(option => {
            const optionItem = document.createElement('div');
            optionItem.className = 'option-item';
            optionItem.style.display = 'flex';
            optionItem.style.alignItems = 'center';
            optionItem.style.padding = '2px';
            optionItem.style.cursor = 'pointer';
            optionItem.style.color = 'white';
            optionItem.style.width = '20%';
            
            if (option.value === selectedValue) {
                optionItem.style.backgroundColor = '#6B7280'; // gray-500
            }
            
            optionItem.innerHTML = `
                <img src="${option.image}" alt="${option.text}" style="width: 20px; height: 20px; margin-right: 8px;">
            `;
            
            optionItem.addEventListener('click', () => {
                onChange(option.value);
                selectedItem.innerHTML = `
                    <img src="${option.image}" alt="${option.text}" style="width: 20px; height: 20px;">
                    <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 120px;">${option.text}</span>
                    <svg style="width: 16px; height: 16px; margin-left: 8px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                `;
                optionsList.style.display = 'none';
            });
            
            optionItem.addEventListener('mouseover', () => {
                optionItem.style.backgroundColor = '#6B7280'; // gray-500
            });
            
            optionItem.addEventListener('mouseout', () => {
                if (option.value !== selectedValue) {
                    optionItem.style.backgroundColor = '';
                }
            });
            
            optionsContainer.appendChild(optionItem);
        });
        
        // Show message if no results
        if (filteredOptions.length === 0) {
            const noResults = document.createElement('div');
            noResults.style.padding = '8px';
            noResults.style.color = '#9CA3AF'; // gray-400
            noResults.textContent = 'No matching icons found';
            optionsContainer.appendChild(noResults);
        }
    }
    
    renderOptions();
    optionsList.appendChild(optionsContainer);
    
    // Search functionality
    searchInput.addEventListener('input', (e) => {
        renderOptions(e.target.value);
    });
    
    // Toggle dropdown
    selectedItem.addEventListener('click', () => {
        const isVisible = optionsList.style.display === 'block';
        optionsList.style.display = isVisible ? 'none' : 'block';
        if (!isVisible) {
            searchInput.focus();
            searchInput.value = '';
            renderOptions();
        }
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
        if (!dropdownContainer.contains(e.target)) {
            optionsList.style.display = 'none';
        }
    });
    
    // Add elements to the container
    dropdownContainer.appendChild(selectedItem);
    dropdownContainer.appendChild(optionsList);
    container.appendChild(dropdownContainer);
    
    return {
        getSelectedValue: () => selectedValue,
        setSelectedValue: (value) => {
            selectedValue = value;
            const option = options.find(opt => opt.value === value) || options[0];
            selectedItem.innerHTML = `
                <img src="${option.image}" alt="${option.text}" style="width: 20px; height: 20px; margin-right: 8px;">
                <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 120px;">${option.text}</span>
                <svg style="width: 16px; height: 16px; margin-left: 8px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
            `;
        }
    };
}

// Try to load the full blips JSON first - using relative paths
fetch('https://dev-posterlabz.site/updated_blips_full.json')
    .then(response => {
        if (!response.ok) {
            throw new Error('Full blips JSON not found');
        }
        return response.json();
    })
    .then(data => {
        const assetBase = `${window.location.origin}/cdn/shop/t/15/assets`;
        blipIcons = data.map(icon => {
            if (icon.image.startsWith('blip_icons/')) {
                const fileName = icon.image.split('/').pop();
                icon.image = `${assetBase}/${fileName}`;
            } else if (icon.image.startsWith('assets/')) {
                const fileName = icon.image.split('/').pop();
                icon.image = `${assetBase}/${fileName}`;
            }
            return icon;
        });
        blipIconsLoaded = true;
        console.log('Blip icons paths:', blipIcons.map(i => i.image));
        updateAllBlipDropdowns();
    })
    .catch(error => {
        console.error('Error loading full blips JSON:', error);
        
        // Fallback to regular blips.json with relative path
        fetch('https://dev-posterlabz.site/blips.json')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Blips JSON not found');
                }
                return response.json();
            })
            .then(data => {
                blipIcons = data;
                blipIconsLoaded = true;
                console.log('Loaded blip icons from fallback:', blipIcons.length);
                
                // Update any existing dropdowns with the fallback list
                updateAllBlipDropdowns();
            })
            .catch(error => {
                console.error('Error loading blips JSON:', error);
                // Final fallback to hardcoded essential blips
                blipIcons = [
                    {
                        "id": "40",
                        "code": "radar_safehouse",
                        "name": "Safehouse",
                        "image": "/assets/radar_safehouse.png"
                    },
                    {
                        "id": "41",
                        "code": "radar_police",
                        "name": "Police",
                        "image": "/assets/radar_police.png"
                    },
                    {
                        "id": "61",
                        "code": "radar_hospital",
                        "name": "Hospital",
                        "image": "/assets/radar_hospital.png"
                    },
                    {
                        "id": "71",
                        "code": "radar_barber",
                        "name": "Barber",
                        "image": "/assets/radar_barber.png"
                    },
                    {
                        "id": "72",
                        "code": "radar_car_mod_shop",
                        "name": "Car Mod Shop",
                        "image": "/assets/radar_car_mod_shop.png"
                    },
                    {
                        "id": "110",
                        "code": "radar_gun_shop",
                        "name": "Gun Shop",
                        "image": "/assets/radar_gun_shop.png"
                    },
                    {
                        "id": "153",
                        "code": "radar_weapon_health",
                        "name": "Weapon Health",
                        "image": "/assets/radar_weapon_health.png"
                    },
                    {
                        "id": "198",
                        "code": "radar_taxi",
                        "name": "Taxi",
                        "image": "/assets/radar_taxi.png"
                    }
                ];
                blipIconsLoaded = true;
                
                // Update any existing dropdowns with the hardcoded list
                updateAllBlipDropdowns();
            });
    });

// Function to update all existing blip dropdowns with the full list
function updateAllBlipDropdowns() {
    // Find all custom dropdowns in the pins list controls
    const dropdownContainers = document.querySelectorAll('#pins-list-controls .blip-dropdown-container');
    
    dropdownContainers.forEach(container => {
        const pinId = container.closest('[data-pin-id]').dataset.pinId;
        const pinData = markers.find(m => m.id === pinId);
        
        if (pinData) {
            // Clear existing dropdown
            container.innerHTML = '';
            
            // Create new dropdown with full list
            createBlipIconDropdownForPin(container, pinData);
        }
    });
}

// Variables to track the initial map state and bounds
let initialBounds = null;
let initialCenter = null;
let initialZoom = null;
let initialContainerWidth = null;
let initialContainerHeight = null;
let boundsSet = false;

// Default map center (New York City)
const defaultCenter = [-74.0060, 40.7128];
const defaultZoom = 10;

// Create the map with default center (will be updated with geolocation if available)
let map; // Declare map variable for later initialization

fetch('https://pub-98bc527a9cff42fab2c1ff5fec1776db.r2.dev/gta/gta_v_style.json')
    .then(response => {
        if (!response.ok) throw new Error('Failed to load GTA V style JSON');
        return response.json();
    })
    .then(gtaVStyle => {
        map = new mapboxgl.Map({
            container: 'map', // container ID in the preview canvas
            style: gtaVStyle, // Use the loaded GTA V style JSON
            center: defaultCenter, // Default center, will be updated with geolocation
            zoom: defaultZoom,
            preserveDrawingBuffer: true,
            attributionControl: false, // Remove default attribution, will add a compact one if needed
            //preserveDrawingBuffer: true // Important for image export later
        });

        window.map = map;
        map.addControl(new mapboxgl.AttributionControl({ compact: true }), 'bottom-right');
        

        // Add navigation controls
        map.addControl(new mapboxgl.NavigationControl(), 'top-left');

        // Create a geocoder control for location search
        const geocoder = new MapboxGeocoder({
            accessToken: mapboxgl.accessToken,
            mapboxgl: mapboxgl,
            marker: false, // We'll handle marker creation ourselves
            placeholder: 'Search for a location',
            zoom: 12,
            flyTo: {
                duration: 1.5 // Smooth fly animation
            }
        });
        map.addControl(geocoder, 'top-right');

        // Handle geocoder result (move this here so geocoder is defined)
        geocoder.on('result', (e) => {
            const { result } = e;
            console.log('Search result:', result);
            // Update subtitle with location name
            if (result.place_name) {
                const placeName = result.text || result.place_name.split(',')[0];
                mapSubtitleInput.value = placeName;
                mapSubtitlePreview.textContent = placeName;
            }
        });

        // Style the geocoder container
        setTimeout(() => {
            const geocoderContainer = document.querySelector('.mapboxgl-ctrl-geocoder');
            if (geocoderContainer) {
                geocoderContainer.style.width = '100%';
                geocoderContainer.style.maxWidth = '300px';
                geocoderContainer.style.marginTop = '10px';
                geocoderContainer.style.marginRight = '10px';
            }
        }, 100);

        // Add the location button to the map
        map.addControl({
            onAdd: function() {
                return createLocationButton();
            },
            onRemove: function() {}
        }, 'top-left');

        // Store initial map state after it's fully loaded
        map.on('load', () => {

            map.setPaintProperty('land-glow0', 'line-width', 5)

            storeCurrentMapState();
            setTimeout(() => {
                showNotification('Click the location button to center the map on your current location', 'info', 6000);
            }, 1000);

            new ResizeObserver(() => {
                isResizing = true;
                map.resize();
                maintainMapView();
                isResizing = false;
            }).observe(document.getElementById('preview-canvas'));

            // Hide all text labels permanently
            const textLayers = ['place-labels', 'poi-labels'];
            textLayers.forEach(layerId => {
                if (map.getLayer(layerId)) {
                    map.setLayoutProperty(layerId, 'visibility', 'none');
                    console.log(`Hidden text layer: ${layerId}`);
                }
            });

            // Make major roads thinner in the preview
            const thinMajorRoadWidth = [
                "interpolate", ["linear"], ["zoom"],
                8, 0.5,
                10, 1,
                14, 2,
                18, 4
            ];
            ["roads-major", "roads-major-outline"].forEach(id => {
                if (map.getLayer(id)) {
                    map.setPaintProperty(id, "line-width", thinMajorRoadWidth);
                }
            });

            // Attach map click handler to add pins
            map.on('click', (e) => {
                addPin(e.lngLat);
            });
        });

        map.on('zoomend', () => {
            if (map.loaded() && !isResizing) {
                storeCurrentMapState();
            }
        });
    })
    .catch(error => {
        showNotification('Failed to load GTA V map style. Using default style.', 'error');
        console.error(error);
        // Fallback: initialize map with default style
        map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/dark-v10',
            center: defaultCenter,
            zoom: defaultZoom,
            attributionControl: false,
            preserveDrawingBuffer: true
        });
        window.map = map;
        map.addControl(new mapboxgl.AttributionControl({ compact: true }), 'bottom-right');
        
    });

// Make markers globally accessible for export
window.markers = markers;

// Sync preview title/subtitle from input fields
mapTitleInput.addEventListener('input', (e) => mapTitlePreview.textContent = e.target.value);
mapSubtitleInput.addEventListener('input', (e) => mapSubtitlePreview.textContent = e.target.value);
// Initial sync
mapTitlePreview.textContent = mapTitleInput.value;
mapSubtitlePreview.textContent = mapSubtitleInput.value;

// Function to get default blip icon (Safehouse)
function getDefaultBlipIcon() {
    return blipIcons.find(blip => blip.code === 'radar_safehouse') || blipIcons[0];
}

// Function to create marker element with selected blip icon
function createMarkerElement(blipIcon) {
    const markerElement = document.createElement('div');
    markerElement.className = 'custom-marker';
    
    // If we have a blip icon, use it; otherwise use default pink circle
    if (blipIcon && blipIcon.image) {
        markerElement.innerHTML = `<img src="${blipIcon.image}" alt="${blipIcon.name}" width="24" height="24" style="filter: drop-shadow(0px 0px 5px #fff);">`;
    } else {
        markerElement.innerHTML = `<svg viewBox="0 0 24 24" width="24" height="24" fill="#FF00FF"><circle cx="12" cy="12" r="10" stroke="white" stroke-width="2"/></svg>`;
    }
    
    return markerElement;
}

// Function to add a pin to the map and lists
function addPin(lngLat, name = `Location ${++pinCounter}`) {
    const defaultBlipIcon = getDefaultBlipIcon();
    const markerElement = createMarkerElement(defaultBlipIcon);

    const marker = new mapboxgl.Marker(markerElement)
        .setLngLat(lngLat)
        .addTo(map);

    const uniqueId = `pin-${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;
    const newPinData = { 
        id: uniqueId, 
        markerInstance: marker, 
        lngLat: lngLat, 
        name: name,
        blipIcon: defaultBlipIcon
    };

    markers.push(newPinData);

    // Add to both control lists
    addPinToControlList(newPinData);
    addPinToControlList_2(newPinData); // ✅ ADD THIS LINE

    addPinToPreviewList(newPinData);
}

function addPinToPreviewList(pinData) {
    if (pinsListPreview.querySelector('p.text-gray-300')) {
        pinsListPreview.innerHTML = ''; 
    }
    const pinElementPreview = document.createElement('div');
    pinElementPreview.className = 'inline-flex items-center bg-black bg-opacity-80 py-1 px-2 text-sm w-max self-end';
    pinElementPreview.dataset.pinId = pinData.id;

    // Use the blip icon if available, otherwise use default pin icon
    const iconHtml = pinData.blipIcon && pinData.blipIcon.image 
        ? `<img src="${pinData.blipIcon.image}" alt="${pinData.blipIcon.name}" class="w-4 h-4 ml-2 flex-shrink-0">`
        : `<svg class="w-4 h-4 text-pink-500 ml-2 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />
        </svg>`;
    
    pinElementPreview.innerHTML = `<span class="text-white chalet-font">${pinData.name}</span>${iconHtml}`;
    pinsListPreview.appendChild(pinElementPreview);
}

function updatePreviewPinName(pinId, newName) {
    const pinElementPreview = pinsListPreview.querySelector(`div[data-pin-id="${pinId}"] span`);
    if (pinElementPreview) {
        pinElementPreview.textContent = newName;
    }
}

function updatePreviewPinIcon(pinId, blipIcon) {
    const pinElementPreview = pinsListPreview.querySelector(`div[data-pin-id="${pinId}"]`);
    if (pinElementPreview) {
        const iconContainer = pinElementPreview.querySelector('img, svg');
        if (iconContainer) {
            iconContainer.remove();
        }
        
        // Add the new icon
        const iconHtml = blipIcon && blipIcon.image 
            ? `<img src="${blipIcon.image}" alt="${blipIcon.name}" class="w-5 h-5 ml-2 flex-shrink-0">`
            : `<svg class="w-5 h-5 text-pink-500 ml-2 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />
            </svg>`;
        
        pinElementPreview.insertAdjacentHTML('beforeend', iconHtml);
    }
}

function removePinFromPreviewList(pinId) {
    const pinElementPreview = pinsListPreview.querySelector(`div[data-pin-id="${pinId}"]`);
    if (pinElementPreview) {
        pinElementPreview.remove();
    }
}

// Function to create blip icon dropdown with image previews
function createBlipIconDropdownForPin(container, pinData) {
    // Create dropdown options from blipIcons
    const options = blipIcons.map(blip => ({
        value: blip.code,
        text: blip.name,
        image: blip.image
    }));
    
    // Get current selected value
    const selectedValue = pinData.blipIcon ? pinData.blipIcon.code : 'radar_safehouse';
    
    // Create custom dropdown
    const dropdown = createCustomDropdown(container, options, selectedValue, (newValue) => {
        const selectedBlip = blipIcons.find(blip => blip.code === newValue);
        
        if (selectedBlip) {
            // Update the marker's icon
            const markerToUpdate = markers.find(m => m.id === pinData.id);
            if (markerToUpdate) {
                markerToUpdate.blipIcon = selectedBlip;
                
                // Remove the old marker from the map
                markerToUpdate.markerInstance.remove();
                
                // Create a new marker with the selected icon
                const newMarkerElement = createMarkerElement(selectedBlip);
                const newMarker = new mapboxgl.Marker(newMarkerElement)
                    .setLngLat(markerToUpdate.lngLat)
                    .addTo(map);
                
                // Update the marker instance
                markerToUpdate.markerInstance = newMarker;
                
                // Update the preview pin icon
                updatePreviewPinIcon(pinData.id, selectedBlip);
                
                // Update the control pin icon
                updateControlPinIcon(pinData.id, selectedBlip);
            }
        }
    });
    
    return dropdown;
}


// === ORIENTATION TOGGLE ===
let currentOrientation = 'portrait'; // default

document.querySelectorAll('[data-citymap="orientation"]').forEach(btn => {
  btn.addEventListener('click', () => {
    // Remove active class
    document.querySelectorAll('[data-citymap="orientation"]').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    // ✅ keep local + global in sync
    currentOrientation = btn.dataset.value; // "portrait" or "landscape"
    window.currentOrientation = currentOrientation;

    // 🔄 Update preview container aspect ratio
    const preview = document.getElementById('preview-canvas');
    if (currentOrientation === 'portrait') {
      preview.style.aspectRatio = '3 / 4';   // Tall preview
      preview.style.maxWidth = '600px';
    } else {
      preview.style.aspectRatio = '16 / 10'; // Wide preview
      preview.style.maxWidth = '100%';
    }

    // Force map resize so it fills correctly
    if (window.map) window.map.resize();
  });
});


// Function to update the control pin icon
function updateControlPinIcon(pinId, blipIcon) {
    const pinElementControl = pinsListControls.querySelector(`div[data-pin-id="${pinId}"]`);
    if (pinElementControl) {
        const iconPreview = pinElementControl.querySelector('.flex-shrink-0.mr-2');
        if (iconPreview) {
            // Update the icon preview
            if (blipIcon && blipIcon.image) {
                iconPreview.innerHTML = `<img src="${blipIcon.image}" alt="${blipIcon.name}" width="24" height="24">`;
            } else {
                iconPreview.innerHTML = `<svg viewBox="0 0 24 24" width="24" height="24" fill="#FF00FF"><circle cx="12" cy="12" r="10" stroke="white" stroke-width="2"/></svg>`;
            }
        }
    }
}

function addPinToControlList(pinData) {
    if (pinsListControls.querySelector('p.text-gray-400')) {
        pinsListControls.innerHTML = ''; 
    }
    const pinElementControl = document.createElement('div');
    pinElementControl.className = 'flex items-center justify-between bg-gray-600 py-1 px-2 rounded mb-1 text-sm w-full';
    pinElementControl.dataset.pinId = pinData.id;

    // Create the pin icon preview
    const iconPreview = document.createElement('div');
    iconPreview.className = 'flex-shrink-0 mr-2';
    iconPreview.style.width = '24px';
    iconPreview.style.height = '24px';
    
    if (pinData.blipIcon && pinData.blipIcon.image) {
        iconPreview.innerHTML = `<img src="${pinData.blipIcon.image}" alt="${pinData.blipIcon.name}" width="24" height="24">`;
    } else {
        iconPreview.innerHTML = `<svg viewBox="0 0 24 24" width="24" height="24" fill="#FF00FF"><circle cx="12" cy="12" r="10" stroke="white" stroke-width="2"/></svg>`;
    }

    pinElementControl.innerHTML = `
        <div class="flex items-center flex-grow">
            <input type="text" value="${pinData.name}" class="bg-transparent text-white outline-none border-none focus:ring-1 focus:ring-pink-500 rounded p-1 flex-grow min-w-0 chalet-font">
        </div>
        <div class="flex items-center">
            <div class="blip-dropdown-container ml-2"></div>
            <button class="remove-pin-btn text-red-500 hover:text-red-700 ml-2 p-1 flex-shrink-0" title="Remove pin">
                <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
            </button>
        </div>
    `;
    
    // Insert the icon preview at the beginning
    pinElementControl.querySelector('.flex.items-center.flex-grow').prepend(iconPreview);
    
    pinsListControls.appendChild(pinElementControl);
    
    // Create the blip icon dropdown
    const dropdownContainer = pinElementControl.querySelector('.blip-dropdown-container');
    createBlipIconDropdownForPin(dropdownContainer, pinData);

    pinElementControl.querySelector('.remove-pin-btn').addEventListener('click', () => {
        pinData.markerInstance.remove();
        const markerIndex = markers.findIndex(m => m.id === pinData.id);
        if (markerIndex > -1) {
            markers.splice(markerIndex, 1);
        }
        pinElementControl.remove();
        removePinFromPreviewList(pinData.id);
        if (pinsListControls.children.length === 0) {
            pinsListControls.innerHTML = '<p class="text-gray-400 text-xs md:text-sm">Click on the map in the preview to add pins.</p>';
        }
    });

    const inputField = pinElementControl.querySelector('input[type="text"]');
    inputField.addEventListener('change', (e) => {
        const updatedName = e.target.value;
        const markerToUpdate = markers.find(m => m.id === pinData.id);
        if (markerToUpdate) {
            markerToUpdate.name = updatedName;
        }
        updatePreviewPinName(pinData.id, updatedName);
    });
}

// Function to store the current map bounds
function storeCurrentMapState() {
    initialBounds = map.getBounds();
    initialCenter = map.getCenter();
    initialZoom = map.getZoom();
    const container = document.getElementById('preview-canvas');
    initialContainerWidth = container.clientWidth;
    initialContainerHeight = container.clientHeight;
    boundsSet = true;
    console.log('Map state stored:', { 
        bounds: initialBounds, 
        center: initialCenter, 
        zoom: initialZoom,
        containerWidth: initialContainerWidth,
        containerHeight: initialContainerHeight
    });
}

// Function to maintain the same geographic area when container resizes
function maintainMapView() {
    if (!boundsSet) return;
    
    // Force the map to show the exact same bounds regardless of container size
    map.fitBounds(initialBounds, {
        animate: false,
        padding: 0
    });
    
    console.log('Map view maintained to match initial bounds');
}

// Function to show notification
function showNotification(message, type = 'info', duration = 5000) {
    // Remove any existing notification
    const existingNotification = document.getElementById('map-notification');
    if (existingNotification) {
        existingNotification.remove();
    }
    
    // Create notification element
    const notification = document.createElement('div');
    notification.id = 'map-notification';
    notification.style.position = 'absolute';
    notification.style.top = '10px';
    notification.style.left = '50%';
    notification.style.transform = 'translateX(-50%)';
    notification.style.padding = '8px 16px';
    notification.style.borderRadius = '4px';
    notification.style.zIndex = '1000';
    notification.style.maxWidth = '80%';
    notification.style.textAlign = 'center';
    
    // Set color based on type
    if (type === 'error') {
        notification.style.backgroundColor = 'rgba(239, 68, 68, 0.9)'; // red
    } else if (type === 'success') {
        notification.style.backgroundColor = 'rgba(34, 197, 94, 0.9)'; // green
    } else {
        notification.style.backgroundColor = 'rgba(59, 130, 246, 0.9)'; // blue
    }
    
    notification.style.color = 'white';
    notification.textContent = message;
    
    // Add to map container
    document.getElementById('map-container').appendChild(notification);
    
    // Remove after duration
    setTimeout(() => {
        if (notification.parentNode) {
            notification.remove();
        }
    }, duration);
}

// Function to get user's location and center the map
function getUserLocationAndCenterMap() {
    if ('geolocation' in navigator) {
        // Show loading indicator
        const loadingEl = document.createElement('div');
        loadingEl.id = 'location-loading';
        loadingEl.style.position = 'absolute';
        loadingEl.style.top = '50%';
        loadingEl.style.left = '50%';
        loadingEl.style.transform = 'translate(-50%, -50%)';
        loadingEl.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
        loadingEl.style.color = 'white';
        loadingEl.style.padding = '10px 20px';
        loadingEl.style.borderRadius = '4px';
        loadingEl.style.zIndex = '1000';
        loadingEl.textContent = 'Getting your location...';
        document.getElementById('map-container').appendChild(loadingEl);
        
        // Try to get user's location
        navigator.geolocation.getCurrentPosition(
            // Success callback
            (position) => {
                const { latitude, longitude } = position.coords;
                
                // Fly to user's location
                map.flyTo({
                    center: [longitude, latitude],
                    zoom: 12,
                    essential: true
                });
                
                // Update subtitle with location name using reverse geocoding
                reverseGeocode(longitude, latitude);
                
                // Remove loading indicator
                document.getElementById('location-loading').remove();
                
                // Show success notification
                showNotification('Location found! Map centered on your current location.', 'success');
                
                console.log('Map centered on user location:', { latitude, longitude });
            },
            // Error callback
            (error) => {
                console.error('Geolocation error:', error);
                
                // Remove loading indicator
                if (document.getElementById('location-loading')) {
                    document.getElementById('location-loading').remove();
                }
                
                // Show appropriate error message based on error code
                let errorMessage = 'Could not get your location. Using default location.';
                
                if (error.code === 1) {
                    // Permission denied
                    if (isSafari()) {
                        errorMessage = 'Location permission denied. On Safari, check your browser settings and ensure this site has location permission.';
                    } else {
                        errorMessage = 'Location permission denied. Please enable location services for this site in your browser settings.';
                    }
                } else if (error.code === 2) {
                    // Position unavailable
                    errorMessage = 'Your location is currently unavailable. Please try again later.';
                } else if (error.code === 3) {
                    // Timeout
                    errorMessage = 'Location request timed out. Please try again.';
                }
                
                // Show error notification
                showNotification(errorMessage, 'error', 8000);
            },
            // Options
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );
    } else {
        showNotification('Geolocation is not supported by your browser.', 'error');
        console.log('Geolocation is not supported by this browser');
    }
}

// Function to detect Safari browser
function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

// Function to reverse geocode coordinates to get location name
function reverseGeocode(longitude, latitude) {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?access_token=${mapboxgl.accessToken}&types=place`;
    
    fetch(url)
        .then(response => response.json())
        .then(data => {
            if (data.features && data.features.length > 0) {
                const placeName = data.features[0].text;
                mapSubtitleInput.value = placeName;
                mapSubtitlePreview.textContent = placeName;
                console.log('Location name updated:', placeName);
            }
        })
        .catch(error => {
            console.error('Error reverse geocoding:', error);
        });
}

// Function to toggle preview mode
function togglePreviewMode(show) {
    const mapControls = document.querySelectorAll('.mapboxgl-ctrl');
    const builderControls = document.getElementById('builder-controls-panel');
    
    if (show) {
        // Hide map controls
        mapControls.forEach(control => {
            control.style.display = 'none';
        });
        
        // Hide builder controls but keep the preview canvas in the same position
        builderControls.style.display = 'none';
        
        // Change the preview button text to indicate it can be used to exit preview
        
        // Resize map to ensure it fits correctly
        map.resize();
    } else {
        // Show map controls
        mapControls.forEach(control => {
            control.style.display = '';
        });
        
        // Show builder controls
        builderControls.style.display = '';
        
        // Reset the preview button text
        
        // Resize map to fit original container
        map.resize();
    }
}

function isIphone() {
  return /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

// High-res export using canvas-based approach
async function downloadHighResPoster() {
    // Use the new CanvasExporter
    if (!window.CanvasExporter) {
        console.error('CanvasExporter not loaded');
        showNotification('Export system not ready. Please refresh the page.', 'error');
        return;
    }

    const exporter = new window.CanvasExporter();

    try {
        if (isIphone()) {
            console.warn('📱 iPhone detected - using fallback export');
            const blob = await exporter.exportFallbackForIOS();

            // Trigger download of fallback image
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `GTA-Map-Poster-iPhone-${Date.now()}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            showNotification('Poster downloaded (iPhone fallback).', 'success');
        } else {
            await exporter.downloadPoster();
            showNotification('Poster downloaded successfully!', 'success');
        }
    } catch (error) {
        console.error('Export failed:', error);
        showNotification('Failed to export poster. Please try again.', 'error');
    }
}

// Preview toggle switch functionality
let isInPreviewMode = false;
document.addEventListener('DOMContentLoaded', () => {
    const previewToggle = document.getElementById('toggle-preview-mode');
    if (previewToggle) {
        previewToggle.addEventListener('change', (e) => {
            isInPreviewMode = e.target.checked;
            
            if (isInPreviewMode) {
                // Hide only map controls (Mapbox controls)
                const mapControls = document.querySelectorAll('.mapboxgl-ctrl');
                mapControls.forEach(control => {
                    control.style.display = 'none';
                });
                console.log('Preview mode ON - Map controls hidden');
            } else {
                // Show map controls
                const mapControls = document.querySelectorAll('.mapboxgl-ctrl');
                mapControls.forEach(control => {
                    control.style.display = '';
                });
                console.log('Preview mode OFF - Map controls visible');
            }
        });
    }
});

// Reset button functionality
document.getElementById('reset-btn').addEventListener('click', () => {
    // Clear all pins first
    markers.forEach(marker => {
        if (marker.markerInstance) {
            marker.markerInstance.remove();
        }
    });
    markers.length = 0; // Clear array completely
    
    // Reset pins list UI
    document.getElementById('pins-list-controls').innerHTML = '<p class="text-gray-400 text-xs md:text-sm">Click on the map in the preview to add pins.</p>';
    document.getElementById('pins-list-preview').innerHTML = '';
    
    // Reset title and subtitle
    document.getElementById('map-title').value = 'GRAND THEFT AUTO';
    document.getElementById('map-subtitle').value = 'New York City';
    document.getElementById('map-title-preview').textContent = 'GRAND THEFT AUTO';
    document.getElementById('map-subtitle-preview').textContent = 'New York City';
    
    // Reset pin counter
    pinCounter = 0;
    
    // Reset preview mode if active
    const previewToggle = document.getElementById('toggle-preview-mode');
    if (previewToggle && previewToggle.checked) {
        previewToggle.checked = false;
        // Show map controls
        const mapControls = document.querySelectorAll('.mapboxgl-ctrl');
        mapControls.forEach(control => {
            control.style.display = '';
        });
        isInPreviewMode = false;
    }
    
    // Reset map state and clear any cached bounds
    initialBounds = null;
    initialCenter = null;
    initialZoom = null;
    boundsSet = false;
    
    // Reset map to default location
    map.flyTo({
        center: defaultCenter,
        zoom: defaultZoom,
        essential: true
    });
    
    // Store new initial state after reset
    setTimeout(() => {
        storeCurrentMapState();
    }, 1000);
    
    // Force a map resize to ensure clean state
    setTimeout(() => {
        map.resize();
    }, 500);
    
    // Show notification
    showNotification('Map design has been reset', 'success', 3000);
    
    console.log('Reset complete - markers array length:', markers.length);
});

// Download button removed - only using Save to Cloud now

document.getElementById('add-to-cart-map').addEventListener('click', async (e) => {
    e.preventDefault();
    // Check if we have the CanvasExporter available
    if (!window.CanvasExporter) {
        alert('Export system not ready. Please refresh the page.');
        return;
    }
    
    try {
        const exporter = new window.CanvasExporter();
        const result = await exporter.uploadToSupabase();
        
        // console.log('Design uploaded successfully:', result);
        
        // Here you can add additional logic for Shopify cart integration
        // For example, you could populate hidden form fields with the URLs:
        // document.querySelector('input[name="properties[FullResImage]"]').value = result.fullResUrl;
        // document.querySelector('input[name="properties[MapConfig]"]').value = JSON.stringify(result.mapConfig);
        
    } catch (error) {
        console.error('Failed to upload design:', error);
    }
});

// Add a note about local file access restrictions
console.log('IMPORTANT: For full functionality, this app should be served over HTTP using a local web server.');
console.log('Browser security restrictions prevent loading local files via fetch when opening HTML files directly.');
console.log('Try using a simple HTTP server like: python -m http.server or VS Code Live Server extension.');

console.log('main-2.js updated with Safari-compatible geolocation button and search functionality');



// === PINS LIST CONTROLS 2 ===
// const pinsListControls_2 = document.getElementById('pins-list-controls-2');

function addPinToControlList_2(pinData) {
    if (pinsListControls_2.querySelector('p.text-gray-400')) {
        pinsListControls_2.innerHTML = ''; 
    }

    const pinElementControl = document.createElement('div');
    pinElementControl.className = 'flex items-center justify-between bg-gray-600 py-1 px-2 rounded mb-1 text-sm w-full';
    pinElementControl.dataset.pinId = pinData.id;

    const iconPreview = document.createElement('div');
    iconPreview.className = 'flex-shrink-0 mr-2';
    iconPreview.style.width = '12px';
    iconPreview.style.height = '12px';

    if (pinData.blipIcon && pinData.blipIcon.image) {
        iconPreview.innerHTML = `<img src="${pinData.blipIcon.image}" alt="${pinData.blipIcon.name}" width="24" height="24">`;
    } else {
        iconPreview.innerHTML = `<svg viewBox="0 0 24 24" width="12" height="12" fill="#FF00FF"><circle cx="12" cy="12" r="10" stroke="white" stroke-width="2"/></svg>`;
    }

    pinElementControl.innerHTML = `
        <div class="flex items-center flex-grow">
            <input type="text" value="${pinData.name}" class="bg-transparent text-white outline-none border-none focus:ring-1 focus:ring-pink-500 rounded p-1 flex-grow min-w-0 chalet-font">
        </div>
        <div class="flex items-center">
            <div class="blip-dropdown-container ml-2"></div>
            <button class="remove-pin-btn text-red-500 hover:text-red-700 ml-2 p-1 flex-shrink-0" title="Remove pin">
                <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
            </button>
        </div>
    `;

    pinElementControl.querySelector('.flex.items-center.flex-grow').prepend(iconPreview);
    pinsListControls_2.appendChild(pinElementControl);

    const dropdownContainer = pinElementControl.querySelector('.blip-dropdown-container');
    createBlipIconDropdownForPin(dropdownContainer, pinData);

    pinElementControl.querySelector('.remove-pin-btn').addEventListener('click', () => {
        pinData.markerInstance.remove();
        const markerIndex = markers.findIndex(m => m.id === pinData.id);
        if (markerIndex > -1) {
            markers.splice(markerIndex, 1);
        }
        pinElementControl.remove();
        removePinFromPreviewList(pinData.id);
        if (pinsListControls_2.children.length === 0) {
            pinsListControls_2.innerHTML = '<p class="text-gray-400 text-xs md:text-sm">Click on the map in the preview to add pins.</p>';
        }
    });

    const inputField = pinElementControl.querySelector('input[type="text"]');
    inputField.addEventListener('change', (e) => {
        const updatedName = e.target.value;
        const markerToUpdate = markers.find(m => m.id === pinData.id);
        if (markerToUpdate) {
            markerToUpdate.name = updatedName;
        }
        updatePreviewPinName(pinData.id, updatedName);
    });
}